/* eslint-disable no-unused-vars */
import _ from 'lodash';
import { getDataPoints } from '../../pages/settings/helper';
import { cleanString } from '@utilities/attachments';

export const searchTasks = ({ searched, data = [], store }) => {
  return new Promise((resolve) => {
    let tasks = data
      ?.filter((task) => {
        const {
          id,
          title,
          description,
          users,
          equipmentAsset = {},
          siteAsset = {},
          rtInterval,
          rtData = {},
          taskFooter,
          hseData,
          mocData,
          structureData,
          structureAsset,
          ncrData,
          pipelineData,
          pipelineAsset,
          incidentNumber,
          detailInspectionsInfo,
          recurrence,
          identifier,
          location,
          taskCardWorkStatus = '',
          taskCardHeaderTitle
        } = task;

        const tasksDataPointsMapCombine = [
          ...(task?.dataPointsForSearch || []),
          ...(task?.dataPoints || [])
        ];

        const tasksDataPointsMap = tasksDataPointsMapCombine?.reduce(
          (obj, item) =>
            Object.assign(obj, {
              [item.key]:
                item.key === 'responsibleUsers' || item.key === 'inspectors'
                  ? users
                    ? (users && users.toString()) || ''
                    : ''
                  : `${item.value}`
            }),
          {}
        );

        if (searched) {
          const filterObject = filterTaskObject({
            taskCardWorkStatus,
            equipmentAsset,
            siteAsset,
            structureAsset,
            // id,
            title,
            taskCardHeaderTitle,
            users,
            tasksDataPointsMap,
            incidentNumber,

            description,
            // rtInterval,
            rtData,
            taskFooter,
            hseData,
            mocData,
            structureData,
            ncrData,
            pipelineData,
            pipelineAsset,
            detailInspectionsInfo,
            inspectionTitle: task?.inspectionType,

            // type:
            //   task?.typeId && picklistsMap[task?.typeId]?.value
            //     ? picklistsMap[task?.typeId]?.value
            //     : '',
            recurrence,
            identifier,
            location
          });

          const cleanInput = cleanString(searched);

          if (
            !Object.values(filterObject).some((value) => {
              // return String(value).toLowerCase().includes(searched.toLowerCase());
              return cleanString(String(value)).includes(cleanInput);
            })
          )
            return false;
        }

        return true;
      })
      ?.map((a) => {
        const dataPoints = a?.dataPointsForSearch || [];
        const cleanInput = a?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';
        if (a?.type === 'New or edited asset') {
          let equipmentAssetFilterData = a?.equipmentAssetFilterData?.prepareTasksEquipments?.map(
            (x) => {
              const dataPoints = x?.dataPointsForSearch || [];
              const cleanInput = x?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';

              let newDataPointsList = dataPoints?.filter((item) => {
                let titleAndValueCombineObject = `${item.title} : ${item.value}`;
                return cleanString(String(titleAndValueCombineObject)).includes(cleanInput);
              });

              const siteDataPoints = x?.siteAsset?.dataPointsForSearch || [];
              const cleanInputForSiteDataPoints =
                x?.siteAsset?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';

              let newDataPointsForSiteList = siteDataPoints.filter((item) => {
                let titleAndValueCombineObject = `${item.title} : ${item.value}`;
                return cleanString(String(titleAndValueCombineObject)).includes(
                  cleanInputForSiteDataPoints
                );
              });

              return {
                ...x,
                dataPoints: searched
                  ? [...(x?.dataPoints || []), ...newDataPointsList]
                  : x?.dataPoints || [],
                siteAsset: {
                  ...x?.siteAsset,
                  dataPoints:
                    x?.siteAsset?.dataPoints?.length > 0 ||
                    x?.siteAsset?.dataPointsForSearch?.length > 0
                      ? searched
                        ? [...(x?.siteAsset?.dataPoints || []), ...(newDataPointsForSiteList || [])]
                        : x?.siteAsset?.dataPoints || []
                      : []
                }
              };
            }
          );

          return {
            ...a,
            equipmentAssetFilterData:
              a?.equipmentAssetFilterData?.equipmentsIds?.length > 0
                ? {
                    equipmentsIds: a?.equipmentAssetFilterData?.equipmentsIds,
                    prepareTasksEquipments: equipmentAssetFilterData
                  }
                : {}
          };
        } else if (a?.type === 'HSE') {
          let siteAsset = a?.siteAsset?.prepareTasksSites?.map((x) => {
            const dataPoints = x?.dataPointsForSearch || [];
            const cleanInput = x?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';
            let newDataPointsList = dataPoints.filter((item) => {
              let titleAndValueCombineObject = `${item.title} : ${item.value}`;
              return cleanString(String(titleAndValueCombineObject)).includes(cleanInput);
            });
            return {
              ...x,
              dataPoints: searched
                ? [...(x?.dataPoints || []), ...newDataPointsList]
                : x?.dataPoints || []
            };
          });

          return {
            ...a,
            siteAsset:
              a?.siteAsset?.sitesIds?.length > 0
                ? {
                    sitesIds: a?.siteAsset?.sitesIds,
                    prepareTasksSites: siteAsset
                  }
                : {}
          };
        } else {
          let newDataPointsList = dataPoints.filter((item) => {
            let titleAndValueCombineObject =
              item.key === 'responsibleUsers'
                ? a?.users
                  ? (a?.users && a?.users.toString()) || ''
                  : ''
                : `${item.value}`;

            return cleanString(String(titleAndValueCombineObject)).includes(cleanInput);
          });

          let sitesAssetFilterData = a?.sitesAssetFilterData?.prepareTasksSites?.map((x) => {
            const dataPoints = x?.dataPointsForSearch || [];

            const cleanInput = x?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';

            let newDataPointsList = dataPoints.filter((item) => {
              let titleAndValueCombineObject = `${item.title} : ${item.value}`;
              return cleanString(String(titleAndValueCombineObject)).includes(cleanInput);
            });

            return {
              ...x,
              dataPoints: searched
                ? [...(x?.dataPoints || []), ...newDataPointsList]
                : x?.dataPoints || []
            };
          });

          let equipmentAssetFilterData = a?.equipmentAssetFilterData?.prepareTasksEquipments?.map(
            (x) => {
              const dataPoints = x?.dataPointsForSearch || [];
              const cleanInput = x?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';

              let newDataPointsList = dataPoints.filter((item) => {
                let titleAndValueCombineObject = `${item.title} : ${item.value}`;
                return cleanString(String(titleAndValueCombineObject)).includes(cleanInput);
              });

              const siteDataPoints = x?.siteAsset?.dataPointsForSearch || [];
              const cleanInputForSiteDataPoints =
                x?.siteAsset?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';

              let newDataPointsForSiteList = siteDataPoints.filter((item) => {
                let titleAndValueCombineObject = `${item.title} : ${item.value}`;
                return cleanString(String(titleAndValueCombineObject)).includes(
                  cleanInputForSiteDataPoints
                );
              });

              return {
                ...x,
                dataPoints: searched
                  ? [...(x?.dataPoints || []), ...newDataPointsList]
                  : x?.dataPoints || [],
                siteAsset: {
                  ...x?.siteAsset,
                  dataPoints:
                    x?.siteAsset?.dataPoints?.length > 0 ||
                    x?.siteAsset?.dataPointsForSearch?.length > 0
                      ? searched
                        ? [...(x?.siteAsset?.dataPoints || []), ...(newDataPointsForSiteList || [])]
                        : x?.siteAsset?.dataPoints || []
                      : []
                }
              };
            }
          );

          let structureAsset = a?.structureAsset?.prepareTasksStructure?.map((x) => {
            const dataPoints = x?.dataPointsForSearch || [];
            const cleanInput = x?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';

            let newDataPointsList = dataPoints.filter((item) => {
              let titleAndValueCombineObject = `${item.title} : ${item.value}`;
              return cleanString(String(titleAndValueCombineObject)).includes(cleanInput);
            });

            const siteDataPoints = x?.siteAsset?.dataPointsForSearch || [];
            const cleanInputForSiteDataPoints =
              x?.siteAsset?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';

            let newDataPointsForSiteList = siteDataPoints.filter((item) => {
              let titleAndValueCombineObject = `${item.title} : ${item.value}`;
              return cleanString(String(titleAndValueCombineObject)).includes(
                cleanInputForSiteDataPoints
              );
            });

            return {
              ...x,
              dataPoints: searched
                ? [...(x?.dataPoints || []), ...newDataPointsList]
                : x?.dataPoints || [],
              siteAsset: {
                ...x?.siteAsset,
                dataPoints:
                  x?.siteAsset?.dataPoints?.length > 0 ||
                  x?.siteAsset?.dataPointsForSearch?.length > 0
                    ? searched
                      ? [...(x?.siteAsset?.dataPoints || []), ...(newDataPointsForSiteList || [])]
                      : x?.siteAsset?.dataPoints || []
                    : []
              }
            };
          });

          let pipelineAsset = a?.pipelineAsset?.prepareTasksPipeline?.map((x) => {
            const dataPoints = x?.dataPointsForSearch || [];
            const cleanInput = x?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';

            let newDataPointsList = dataPoints.filter((item) => {
              let titleAndValueCombineObject = `${item.title} : ${item.value}`;
              return cleanString(String(titleAndValueCombineObject)).includes(cleanInput);
            });

            let multipleSiteAssets = x?.multipleSiteAssets?.map((multipleSiteAsset) => {
              const prepareTasksSites = multipleSiteAsset?.prepareTasksSites?.map((x) => {
                const dataPoints = x?.dataPointsForSearch || [];

                const cleanInput = x?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';

                let newDataPointsList = dataPoints.filter((item) => {
                  let titleAndValueCombineObject = `${item.title} : ${item.value}`;
                  return cleanString(String(titleAndValueCombineObject)).includes(cleanInput);
                });

                return {
                  ...x,
                  dataPoints: searched
                    ? [...(x?.dataPoints || []), ...newDataPointsList]
                    : x?.dataPoints || []
                };
              });

              return {
                ...multipleSiteAsset,
                prepareTasksSites: prepareTasksSites
              };
            });

            return {
              ...x,
              dataPoints: searched
                ? [...(x.dataPoints || []), ...newDataPointsList]
                : x?.dataPoints || [],
              multipleSiteAssets
            };
          });

          return {
            ...a,
            dataPoints: searched ? [...a.dataPoints, ...newDataPointsList] : a?.dataPoints,

            sitesAssetFilterData:
              a?.sitesAssetFilterData?.sitesIds?.length > 0
                ? {
                    sitesIds: a?.sitesAssetFilterData?.sitesIds,
                    prepareTasksSites: sitesAssetFilterData
                  }
                : {},

            equipmentAssetFilterData:
              a?.equipmentAssetFilterData?.equipmentsIds?.length > 0
                ? {
                    equipmentsIds: a?.equipmentAssetFilterData?.equipmentsIds,
                    prepareTasksEquipments: equipmentAssetFilterData
                  }
                : {},

            structureAsset:
              a?.structureAsset?.prepareTasksStructure?.length > 0
                ? {
                    sitesIds: a?.structureAsset?.sitesIds,
                    prepareTasksStructure: structureAsset
                  }
                : {},

            pipelineAsset:
              a?.pipelineAsset?.prepareTasksPipeline?.length > 0
                ? {
                    sitesIds: a?.pipelineAsset?.sitesIds,
                    prepareTasksPipeline: pipelineAsset
                  }
                : {}
          };
        }
      });

    return resolve(tasks);
  });
};

export const searchSites = ({ searched, data = [], store }) => {
  const { picklists, settings } = store;
  const siteHiddenDisplayFields = settings?.hiddenDataPointsForAssets?.site || '';

  const areaHierarchyTreeDataMap = picklists?.areaHierarchyTreeDataMap || {};
  return new Promise((resolve) => {
    let filteredSites = data
      ?.filter((props) => {
        const {
          siteId: localSiteId,
          name,
          distance,
          status,
          siteType: type,
          areaHierarchy,
          parent,
          dataPoints,
          dataPointsForSearch = []
        } = props;
        const title = parent
          ? 'View all work at'
          : areaHierarchyTreeDataMap[areaHierarchy]?.title || '';

        if (!_.isEmpty(searched)) {
          const dataPointsCombine = [...dataPointsForSearch, ...dataPoints];

          const dataPointsObject = dataPointsCombine.reduce(
            (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
            {}
          );
          const filterObject = {
            name,
            title,
            ...dataPointsObject
          };

          const cleanInput = cleanString(searched);

          if (
            !Object.values(filterObject).some((value) => {
              // return String(value).toLowerCase().includes(searched?.toLowerCase());
              return cleanString(String(value)).includes(cleanInput);
            })
          )
            return false;
        }

        return true;
      })
      ?.map((a) => {
        const dataPoints = a?.dataPointsForSearch || [];
        const cleanInput = a?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';

        let newDataPointsList = dataPoints.filter((item) => {
          let titleAndValueCombineObject = `${item.title} : ${item.value}`;
          return cleanString(String(titleAndValueCombineObject)).includes(cleanInput);
        });

        return {
          ...a,
          dataPoints: searched ? [...a.dataPoints, ...newDataPointsList] : a?.dataPoints
        };
      });

    return resolve(filteredSites);
  });
};

export const searchEquipments = ({ searched, data = [], store }) => {
  const { picklists, cache, jurisdictionNumbers, settings } = store;
  const { areaHierarchyTreeDataMap = {}, picklistsMap = {} } = picklists;
  const { jurisdictionNumbersMap = {} } = jurisdictionNumbers;
  const equipmentDisplayFields = settings.settings?.['equipmentDisplayFields'] || '';
  const siteDisplayFields = settings.settings?.['siteDisplayFields'] || '';
  const siteHiddenDisplayFields = settings.hiddenDataPointsForAssets?.site || '';
  const equipmentHiddenDisplayFields = settings.hiddenDataPointsForAssets?.equipment || '';

  const { sitesMap, sites: cacheSites = [] } = cache;
  return new Promise((resolve) => {
    const equipmentsWithDataPoints = data;

    // data?.map((props) => {
    //   const { jurisdictionNumber } = jurisdictionNumbersMap[props.equipmentId] || {};

    //   const dataPoints = getDataPoints(
    //     { ...props, subtype: props.equipmentSubType, jurisdictionNumber },
    //     equipmentDisplayFields,
    //     'equipment',
    //     picklistsMap
    //   );
    //   return {
    //     ...props,
    //     dataPoints
    //   };
    // });

    let filteredEquipment = equipmentsWithDataPoints
      ?.filter((equipment) => {
        const {
          equipmentId: localEquipmentId,
          name,
          status,
          siteId,
          equipmentType: type,
          equipmentCategory: category,
          equipmentSubType: subType,
          allTasksForSite,
          dataPoints,
          dataPointsForSearch = []
        } = equipment;

        const site = cacheSites[sitesMap[siteId]] || {};

        const categoryName = picklistsMap[category]?.value;
        const typeName = picklistsMap[type]?.value;

        const title = `${categoryName} - ${typeName}`;
        const siteTitle = site?.parent
          ? 'View all work at'
          : areaHierarchyTreeDataMap[site?.areaHierarchy || '']?.title || '';

        const equipmentDataPointsCombine = [...dataPointsForSearch, ...dataPoints];

        const dataPointsObject = equipmentDataPointsCombine?.reduce(
          (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
          {}
        );

        const dataPointsForSite = siteDisplayFields
          ? equipment?.dataPointsForSite
            ? equipment?.dataPointsForSite
            : getDataPoints(
                { ...site, type: site.siteType },
                siteDisplayFields,
                'site',
                picklistsMap
              )
          : [];

        const siteDataPointsForSearch = siteHiddenDisplayFields
          ? equipment?.siteDataPointsForSearch
            ? equipment?.siteDataPointsForSearch
            : getDataPoints(
                { ...site, type: site?.siteType },
                siteHiddenDisplayFields,
                'site',
                picklistsMap
              )
          : [];

        const siteDataPointsCombine = [...siteDataPointsForSearch, ...dataPointsForSite];

        const dataPointsObjectFOrSite = siteDataPointsCombine.reduce(
          (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
          {}
        );

        const filterObject = {
          name,
          title,
          siteTitle,
          siteName: site?.name || '',
          ...dataPointsObject,
          ...dataPointsObjectFOrSite
        };
        const cleanInput = cleanString(searched);

        if (
          !Object.values(filterObject).some((value) => {
            return cleanString(String(value)).includes(cleanInput);

            // return String(value).toLowerCase().includes(searched?.toLowerCase());
          })
        )
          return false;

        return true;
      })
      ?.map((a) => {
        const dataPoints = a?.dataPointsForSearch || [];
        const cleanInput = a?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';

        let newDataPointsList = dataPoints.filter((item) => {
          let titleAndValueCombineObject = `${item.title} : ${item.value}`;
          return cleanString(String(titleAndValueCombineObject)).includes(cleanInput);
        });

        const siteDataPoints = a?.siteDataPointsForSearch || [];
        const cleanInputForSiteDataPoints =
          a?.siteDataPointsForSearch?.length > 0 ? cleanString(searched) : '';

        let newDataPointsForSiteList = siteDataPoints.filter((item) => {
          let titleAndValueCombineObject = `${item.title} : ${item.value}`;
          return cleanString(String(titleAndValueCombineObject)).includes(
            cleanInputForSiteDataPoints
          );
        });

        return {
          ...a,
          dataPoints: searched ? [...a.dataPoints, ...newDataPointsList] : a?.dataPoints,
          siteDataPoints:
            a?.dataPointsForSite?.length > 0 || a?.siteDataPointsForSearch?.length > 0
              ? searched
                ? [...a.dataPointsForSite, ...newDataPointsForSiteList]
                : a?.dataPointsForSite
              : []
        };
      });

    return resolve(filteredEquipment);
  });
};

export const searchStructures = ({ searched, data = [], store }) => {
  const { picklists, cache, jurisdictionNumbers, settings } = store;
  const { areaHierarchyTreeDataMap = {}, picklistsMap = {} } = picklists;
  const { jurisdictionNumbersMap = {} } = jurisdictionNumbers;
  const structureDisplayFields = settings.settings?.['structureDisplayFields'] || '';
  const equipmentDisplayFields = settings.settings?.['equipmentDisplayFields'] || '';
  const siteDisplayFields = settings.settings?.['siteDisplayFields'] || '';
  const siteHiddenDisplayFields = settings.hiddenDataPointsForAssets?.site || '';
  const structureHiddenDisplayFields = settings.hiddenDataPointsForAssets?.structure || '';

  const { sitesMap, sites: cacheSites = [] } = cache;
  return new Promise((resolve) => {
    const structuresWithDataPoints = data;
    // data?.map((props) => {
    //   const { jurisdictionNumber } = jurisdictionNumbersMap[props.equipmentId] || {};

    //   const dataPoints = getDataPoints(
    //     { ...props, subtype: props.equipmentSubType, jurisdictionNumber },
    //     structureDisplayFields,
    //     'structure',
    //     picklistsMap
    //   );
    //   return {
    //     ...props,
    //     dataPoints
    //   };
    // });

    let filteredStructure = structuresWithDataPoints
      ?.filter((structure) => {
        const {
          structureId: localEquipmentId,
          name,
          status,
          siteId,
          structureType: type,
          allTasksForStructure,
          dataPoints,
          dataPointsForSearch = []
        } = structure;

        const site = cacheSites[sitesMap[siteId]] || {};

        const typeName = picklistsMap[type]?.value;

        const title = `${typeName}`;
        const siteTitle = site?.parent
          ? 'View all work at'
          : areaHierarchyTreeDataMap[site?.areaHierarchy || '']?.title || '';

        const structureDataPointsCombine = [...dataPointsForSearch, ...dataPoints];

        const dataPointsObject = structureDataPointsCombine.reduce(
          (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
          {}
        );

        const dataPointsForSite = siteDisplayFields
          ? structure?.dataPointsForSite
            ? structure?.dataPointsForSite
            : getDataPoints(
                { ...site, type: site.siteType },
                siteDisplayFields,
                'site',
                picklistsMap
              )
          : [];

        const siteDataPointsForSearch = siteHiddenDisplayFields
          ? structure?.siteDataPointsForSearch
            ? structure?.siteDataPointsForSearch
            : getDataPoints(
                { ...site, type: site?.siteType },
                siteHiddenDisplayFields,
                'site',
                picklistsMap
              )
          : [];

        const siteDataPointsCombine = [...siteDataPointsForSearch, ...dataPointsForSite];

        const dataPointsObjectFOrSite = siteDataPointsCombine.reduce(
          (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
          {}
        );

        const filterObject = {
          name,
          title,
          siteTitle,
          siteName: site?.name || '',
          ...dataPointsObject,
          ...dataPointsObjectFOrSite
        };

        const cleanInput = cleanString(searched);

        if (
          !Object.values(filterObject).some((value) => {
            // return String(value).toLowerCase().includes(searched?.toLowerCase());
            return cleanString(String(value)).includes(cleanInput);
          })
        )
          return false;

        return true;
      })
      ?.map((a) => {
        const dataPoints = a?.dataPointsForSearch || [];
        const cleanInput = a?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';

        let newDataPointsList = dataPoints.filter((item) => {
          let titleAndValueCombineObject = `${item.title} : ${item.value}`;
          return cleanString(String(titleAndValueCombineObject)).includes(cleanInput);
        });

        const siteDataPoints = a?.siteDataPointsForSearch || [];
        const cleanInputForSiteDataPoints =
          a?.siteDataPointsForSearch?.length > 0 ? cleanString(searched) : '';

        let newDataPointsForSiteList = siteDataPoints.filter((item) => {
          let titleAndValueCombineObject = `${item.title} : ${item.value}`;
          return cleanString(String(titleAndValueCombineObject)).includes(
            cleanInputForSiteDataPoints
          );
        });

        return {
          ...a,
          dataPoints: searched ? [...a.dataPoints, ...newDataPointsList] : a?.dataPoints,
          siteDataPoints:
            a?.dataPointsForSite?.length > 0 || a?.siteDataPointsForSearch?.length > 0
              ? searched
                ? [...a.dataPointsForSite, ...newDataPointsForSiteList]
                : a?.dataPointsForSite
              : []
        };
      });

    return resolve(filteredStructure);
  });
};

export const searchPipelines = ({ searched, data = [], store }) => {
  const { picklists, cache, settings } = store;
  const { areaHierarchyTreeDataMap = {}, picklistsMap = {} } = picklists;
  const siteHiddenDisplayFields = settings.hiddenDataPointsForAssets?.site || '';
  const pipelineHiddenDisplayFields = settings.hiddenDataPointsForAssets?.pipeline || '';

  const pipelineDisplayFields = settings.settings?.['pipelineDisplayFields'] || '';
  const siteDisplayFields = settings.settings?.['siteDisplayFields'] || '';
  const { sitesMap, sites: cacheSites = [] } = cache;
  return new Promise((resolve) => {
    const pipelinesWithDataPoints = data;
    //  data?.map((props) => {
    //   const dataPoints = getDataPoints(
    //     {
    //       ...props,
    //       area: areaHierarchyTreeDataMap[props?.area]?.title,
    //       type: props?.pipelineTypeId || null,
    //       approvalNumber: props?.ApprovalNumber || null
    //     },
    //     pipelineDisplayFields,
    //     'pipeline',
    //     picklistsMap
    //   );
    //   return {
    //     ...props,
    //     dataPoints
    //   };
    // });
    let filteredPipeline = pipelinesWithDataPoints
      ?.filter((pipeline) => {
        const {
          toLocation,
          fromLocation,
          licenseNumber,
          lineNumber,
          siteId = '',

          dataPoints,
          dataPointsForSearch = [],
          siteIds = []
        } = pipeline;

        // const site = cacheSites[sitesMap[siteId]] || {};

        const title = `${licenseNumber} - ${lineNumber}`;
        const title1 = `${licenseNumber}-${lineNumber}`;

        const pipelineDataPointsCombine = [...dataPointsForSearch, ...dataPoints];

        const dataPointsObject = pipelineDataPointsCombine.reduce(
          (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
          {}
        );

        const sites = siteIds?.map((x) => cacheSites[sitesMap[x]] || {});

        const sitesTitle =
          sites
            ?.map((x) =>
              x?.parent
                ? 'View all work at'
                : areaHierarchyTreeDataMap[x?.areaHierarchy || '']?.title || ''
            )
            .reduce((acc, name, index) => {
              acc[`siteTitle${index}`] = name;
              return acc;
            }, {}) || [];

        const siteName =
          sites
            ?.map((x) => {
              return x.name;
            })
            ?.reduce((acc, name, index) => {
              acc[`siteName${index}`] = name;
              return acc;
            }, {}) || [];

        const dataPointsForSite = sites.flatMap((x) => {
          const dataPointsForSite = siteDisplayFields
            ? pipeline?.dataPointsForSite[x.siteId]
              ? pipeline?.dataPointsForSite[x.siteId]
              : getDataPoints({ ...x, type: x.siteType }, siteDisplayFields, 'site', picklistsMap)
            : [];

          const siteDataPointsForSearch = siteHiddenDisplayFields
            ? pipeline?.siteDataPointsForSearch[x.siteId]
              ? pipeline?.siteDataPointsForSearch[x.siteId]
              : getDataPoints(
                  { ...x, type: x?.siteType },
                  siteHiddenDisplayFields,
                  'site',
                  picklistsMap
                )
            : [];

          const siteDataPointsCombine = [...siteDataPointsForSearch, ...dataPointsForSite];

          return siteDataPointsCombine;
        });

        const dataPointsObjectFOrSite = dataPointsForSite.reduce((acc, item, index) => {
          acc[`${[item.key]}${index}`] = `${item.title} : ${item.value}`;
          return acc;
        }, {});

        const filterObject = {
          title,
          title1,
          toLocation,
          fromLocation,
          ...sitesTitle,
          ...siteName,
          ...dataPointsObject,
          ...dataPointsObjectFOrSite
        };

        const cleanInput = cleanString(searched);

        if (
          !Object.values(filterObject).some((value) => {
            return cleanString(String(value)).includes(cleanInput);
          })
        )
          return false;

        return true;
      })
      .sort((a, b) => {
        if (a?.licenseNumber === b?.licenseNumber) return a?.lineNumber - b?.lineNumber;
        else return a?.licenseNumber - b?.licenseNumber;
      })
      ?.map((a) => {
        const dataPoints = a?.dataPointsForSearch || [];
        const cleanInput = a?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';

        let newDataPointsList = dataPoints.filter((item) => {
          let titleAndValueCombineObject = `${item.title} : ${item.value}`;
          return cleanString(String(titleAndValueCombineObject)).includes(cleanInput);
        });

        // create site data points
        // dataPointsForSite;
        // siteDataPointsForSearch;

        let newPoints = {};

        for (let siteId of a?.siteIds || []) {
          const siteDataPoints = a?.siteDataPointsForSearch[siteId] || [];

          const cleanInputForSiteDataPoints =
            a?.siteDataPointsForSearch?.[siteId]?.length > 0 ? cleanString(searched) : '';

          let newDataPointsForSiteList = siteDataPoints.filter((item) => {
            let titleAndValueCombineObject = `${item.title} : ${item.value}`;
            return cleanString(String(titleAndValueCombineObject)).includes(
              cleanInputForSiteDataPoints
            );
          });

          if (
            a?.dataPointsForSite[siteId]?.length > 0 ||
            a?.siteDataPointsForSearch?.[siteId]?.length > 0
          ) {
            if (searched) {
              newPoints = {
                ...newPoints,
                [siteId]: [...a.dataPointsForSite[siteId], ...newDataPointsForSiteList]
              };
            } else {
              newPoints = {
                ...newPoints,
                [siteId]: a.dataPointsForSite[siteId]
              };
            }
          }
        }

        return {
          ...a,
          dataPoints: searched ? [...a.dataPoints, ...newDataPointsList] : a?.dataPoints,
          newPointsForSiteIds: newPoints
        };
      });

    return resolve(filteredPipeline);
  });
};

const filterTaskObject = ({
  equipmentAsset,
  siteAsset,
  users,
  id,
  title,
  description,
  rtInterval,
  rtData,
  hseData,
  mocData,
  structureData,
  structureAsset,
  ncrData,
  pipelineData,
  pipelineAsset,
  incidentNumber,
  type,
  detailInspectionsInfo,
  inspectionTitle,
  recurrence,
  identifier,
  location,
  tasksDataPointsMap,
  reconciliationNumber,
  taskCardHeaderTitle,
  taskCardWorkStatus
}) => {
  const equipmentObject = equipmentAsset?.prepareTasksEquipments?.map((x) => {
    const { dataPoints = [], siteAsset = {}, dataPointsForSearch = [] } = x;

    const equipmentDataPointsCombine = [...dataPointsForSearch, ...dataPoints];

    const dataPointsEquipmentObject = equipmentDataPointsCombine?.reduce(
      (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
      {}
    );

    const equipmentSiteDataPoints = [
      ...(siteAsset?.dataPoints || []),
      ...(siteAsset?.dataPointsForSearch || [])
    ];

    const dataPointsSiteObject = equipmentSiteDataPoints?.reduce(
      (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
      {}
    );

    return {
      title: x?.title || '',
      subtitle: x?.subtitle || '',
      siteTitle: siteAsset?.title || '',
      siteSubtitle: siteAsset?.subtitle || '',
      kmValue: siteAsset?.kmValue || '',
      unit: siteAsset?.unit || '',
      ...dataPointsEquipmentObject,
      ...dataPointsSiteObject
    };
  });

  const siteObject = siteAsset?.prepareTasksSites?.map((x) => {
    const { dataPoints = [], dataPointsForSearch = [] } = x;

    const dataPointsCombine = [...dataPointsForSearch, ...dataPoints];

    const dataPointsSiteObject = dataPointsCombine?.reduce(
      (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
      {}
    );

    return {
      title: x?.title || '',
      subtitle: x?.subtitle || '',
      kmValue: x?.kmValue || '',
      unit: x?.unit || '',
      ...dataPointsSiteObject
    };
  });

  const structureObject = structureAsset?.prepareTasksStructure?.map((x) => {
    const { dataPoints = [], siteAsset = {}, dataPointsForSearch = [] } = x;

    const siteDataPointsCombine = [...dataPoints, ...dataPointsForSearch];

    const dataPointsStructureObject = siteDataPointsCombine.reduce(
      (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
      {}
    );

    const equipmentSiteDataPoints = [
      ...(siteAsset?.dataPoints || []),
      ...(siteAsset?.dataPointsForSearch || [])
    ];

    const dataPointsSiteObject = equipmentSiteDataPoints?.reduce(
      (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
      {}
    );

    return {
      title: x?.structureType || '',
      subtitle: x?.name || '',
      siteTitle: siteAsset?.title || '',
      siteSubtitle: siteAsset?.subtitle || '',
      kmValue: siteAsset?.kmValue || '',
      unit: siteAsset?.unit || '',
      ...dataPointsStructureObject,
      ...dataPointsSiteObject
    };
  });

  const pipelineObject = pipelineAsset?.prepareTasksPipeline?.map((x) => {
    const {
      dataPoints = [],
      siteAsset = {},
      multipleSiteAssets = [],
      dataPointsForSearch = []
    } = x;

    const siteDataPointsCombine = [...dataPoints, ...dataPointsForSearch];

    const dataPointsPipelineObject = siteDataPointsCombine.reduce(
      (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
      {}
    );
    // const dataPointsSiteObject = siteAsset?.dataPoints?.reduce(
    //   (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
    //   {}
    // );

    let dataPointsPipelineSiteObject = multipleSiteAssets?.map((x) => {
      const { dataPoints = [], dataPointsForSearch = [] } = x?.prepareTasksSites?.[0] || {};

      const siteDataPointsCombine1 = [...dataPoints, ...dataPointsForSearch];

      const dataPointsSiteObject = siteDataPointsCombine1?.reduce(
        (obj, item) =>
          Object.assign(obj, { [`${item.key}-${item.value}`]: `${item.title} : ${item.value}` }),
        {}
      );

      return {
        title: x?.title || '',
        subtitle: x?.subtitle || '',
        kmValue: x?.kmValue || '',
        unit: x?.unit || '',
        ...dataPointsSiteObject
      };
    });

    dataPointsPipelineSiteObject = dataPointsPipelineSiteObject?.reduce((acc, obj, index) => {
      Object.keys(obj).forEach((key) => {
        acc[`${key}-pipeline-site`] = obj[key];
      });
      return acc;
    }, {});

    return {
      title: `${x.licenseNumber}-${x.lineNumber}`,
      to: x?.toLocation || '',
      from: x?.fromLocation || '',
      siteTitle: siteAsset?.title || '',
      siteSubtitle: siteAsset?.subtitle || '',
      kmValue: siteAsset?.kmValue || '',
      unit: siteAsset?.unit || '',
      ...dataPointsPipelineObject,
      ...dataPointsPipelineSiteObject
    };
  });

  const transformedObjEquipment = equipmentObject?.reduce((acc, obj, index) => {
    Object.keys(obj).forEach((key) => {
      acc[`${key}-equipment`] = obj[key];
    });
    return acc;
  }, {});

  const transformedObjStructure = structureObject?.reduce((acc, obj, index) => {
    Object.keys(obj).forEach((key) => {
      acc[`${key}-structure`] = obj[key];
    });
    return acc;
  }, {});

  const transformedObjPipeline = pipelineObject?.reduce((acc, obj, index) => {
    Object.keys(obj).forEach((key) => {
      acc[`${key}-pipeline`] = obj[key];
    });
    return acc;
  }, {});

  const transformedObjSite = siteObject?.reduce((acc, obj, index) => {
    Object.keys(obj).forEach((key) => {
      acc[`${key}-site`] = obj[key];
    });
    return acc;
  }, {});

  const hseDataFilterObjects = !_.isEmpty(hseData) ? appliesToTypesDataPoints(hseData, 'hse') : {};
  const mocDataFilterObjects = !_.isEmpty(mocData) ? appliesToTypesDataPoints(mocData, 'moc') : {};

  const ncrDataFilterObjects = !_.isEmpty(ncrData) ? appliesToTypesDataPoints(ncrData, 'ncr') : {};

  const detailInspectionsInfoObjects = detailInspectionsInfo?.reduce((acc, obj, index) => {
    Object.keys(obj).forEach((key) => {
      acc[`${key}-inspection-info`] = obj[key];
    });
    return acc;
  }, {});

  const filterObject = {
    // id,
    title,
    reconciliationNumber,
    taskCardWorkStatus,
    taskCardHeaderTitle,
    type,
    description,
    incidentNumber,
    rtInterval,
    inspectionTitle,
    recurrence,
    identifier,
    location,
    users: (users && users.toString()) || '',
    ...transformedObjSite,
    ...transformedObjEquipment,
    rtDataId: rtData?.id || '',
    rtDataTitle: rtData?.title || '',
    // detailInspectionsInfo,
    ...hseDataFilterObjects,
    ...mocDataFilterObjects,
    ...ncrDataFilterObjects,
    ...transformedObjStructure,
    ...transformedObjPipeline,
    ...tasksDataPointsMap,
    ...detailInspectionsInfoObjects
  };
  return filterObject;
};

const appliesToTypesDataPoints = (typeOfData = {}, keyName = 'hse') => {
  const hseSiteAssetDataPoints =
    typeOfData?.siteAsset?.dataPoints &&
    typeOfData?.siteAsset?.dataPoints?.reduce(
      (obj, item) =>
        Object.assign(obj, { [`${item.key}-${keyName}-site`]: `${item.title} : ${item.value}` }),
      {}
    );

  const hseEquipmentAssetDataPoints =
    typeOfData?.equipmentAsset?.dataPoints &&
    typeOfData?.equipmentAsset?.dataPoints?.reduce(
      (obj, item) =>
        Object.assign(obj, {
          [`${item.key}-${keyName}-equipment`]: `${item.title} : ${item.value}`
        }),
      {}
    );

  const hseEquipmentSiteAssetDataPoints =
    typeOfData?.equipmentAsset?.siteAsset &&
    typeOfData?.equipmentAsset?.siteAsset?.dataPoints &&
    typeOfData?.equipmentAsset?.siteAsset?.dataPoints?.reduce(
      (obj, item) =>
        Object.assign(obj, {
          [`${item.key}-${keyName}-equipment-site`]: `${item.title} : ${item.value}`
        }),
      {}
    );

  const typeOfDataFilterObjects = {
    [`recordNumber-${keyName}`]: typeOfData?.recordNumber || '',
    [`recordTitle-${keyName}}`]: typeOfData?.recordTitle || '',
    [`siteAsset-title-${keyName}`]: typeOfData?.siteAsset?.title || '',
    [`siteAsset-subtitle-${keyName}`]: typeOfData?.siteAsset?.subtitle || '',
    [`siteAsset-kmValue-${keyName}`]: typeOfData?.siteAsset?.kmValue || '',
    [`siteAsset-unit-${keyName}`]: typeOfData?.siteAsset?.unit || '',

    [`equipmentAsset-title-${keyName}`]: typeOfData?.equipmentAsset?.title || '',
    [`equipmentAsset-subtitle-${keyName}`]: typeOfData?.equipmentAsset?.subtitle || '',

    [`equipmentAsset-siteAsset-title-${keyName}`]:
      typeOfData?.equipmentAsset?.siteAsset?.title || '',
    [`equipmentAsset-siteAsset-subtitle-${keyName}`]:
      typeOfData?.equipmentAsset?.siteAsset?.subtitle || '',
    [`equipmentAsset-siteAsset-kmValue-${keyName}`]:
      typeOfData?.equipmentAsset?.siteAsset?.kmValue || '',
    [`equipmentAsset-siteAsset-unit-${keyName}`]: typeOfData?.equipmentAsset?.siteAsset?.unit || '',

    [`pipelineAsset-fromLocation-${keyName}`]: typeOfData?.pipelineAsset?.fromLocation || '',
    [`pipelineAsset-toLocation-${keyName}`]: typeOfData?.pipelineAsset?.toLocation || '',
    [`pipelineAsset-licenseNumber-${keyName}`]: typeOfData?.pipelineAsset?.licenseNumber || '',
    [`pipelineAsset-length-${keyName}`]: typeOfData?.pipelineAsset?.length || '',

    [`structureData-name-${keyName}`]: typeOfData?.structureData?.name || '',
    [`structureData-structureNumberAuto-${keyName}`]:
      typeOfData?.structureData?.structureNumberAuto || '',
    [`structureData-structureType-${keyName}`]: typeOfData?.structureData?.structureType || '',

    ...hseEquipmentSiteAssetDataPoints,
    ...hseSiteAssetDataPoints,
    ...hseEquipmentAssetDataPoints
  };
  return typeOfDataFilterObjects;
};

export const searchRts = ({ searched, data = [] }) => {
  return new Promise((resolve) => {
    const filteredRTs = data?.filter((rt) => {
      const { title, id } = rt;
      const filterObject = {
        id,
        title
      };
      const cleanInput = cleanString(searched);

      if (
        !Object.values(filterObject).some((value) => {
          // return String(value).toLowerCase().includes(searched?.toLowerCase());
          return cleanString(String(value)).includes(cleanInput);
        })
      )
        return false;
      return true;
    });
    return resolve(filteredRTs);
  });
};

export const searchRuns = ({ searched, data = [] }) => {
  return new Promise((resolve) => {
    const filteredRuns = data?.filter((rt) => {
      const { title, id } = rt;

      const filterObject = {
        id,
        title
      };

      const cleanInput = cleanString(searched);

      if (
        !Object.values(filterObject).some((value) => {
          // return String(value).toLowerCase().includes(searched?.toLowerCase());
          return cleanString(String(value)).includes(cleanInput);
        })
      )
        return false;
      return true;
    });
    return resolve(filteredRuns);
  });
};
